import { error as logErrorToConsole } from '@ms/yammer-console-logging';
import { enqueueTelemetryEvents, getTelemetryClientConfig } from '@ms/yammer-telemetry-store';

import { AnalyticsEvent, AnalyticsEventName, BaseTelemetryEvent, TelemetryEventType } from '../events';

import { getReportAnalyticsEventsInput } from './reportAnalyticsEventsInput';
import { getThrottledReportAnalyticsEventsInBatch } from './reportInBatches';
import { reportAnalyticsEventsNow } from './reportTelemetryEventsToServer';

const eventsAllowedForReportNow = [
  AnalyticsEventName.EcsExperimentTreatment.toString(),
  AnalyticsEventName.ExternalLinkClicked.toString(),
  AnalyticsEventName.FeedbackFormOpened.toString(),
  AnalyticsEventName.FeedbackFormSubmitted.toString(),
  AnalyticsEventName.GroupOverFlowMenuItemClicked.toString(),
  AnalyticsEventName.QAndAAppAdded.toString(),
  AnalyticsEventName.CreateTeamsMeetingRequested.toString(),
  AnalyticsEventName.TeamsQnANotSetupPageOpened.toString(),
];

type EnqueueAndThrottleReportAnalyticsEvents = <T extends BaseTelemetryEvent>(events: T[]) => void;
export const enqueueAndThrottleReportAnalyticsEvents: EnqueueAndThrottleReportAnalyticsEvents = <
  T extends BaseTelemetryEvent
>(
  events: T[]
) => {
  enqueueTelemetryEvents<T>(TelemetryEventType.Analytics, events);
  const throttledReportAction = getThrottledReportAnalyticsEventsInBatch(
    getTelemetryClientConfig().eventReportIntervalInMilliseconds
  );

  throttledReportAction();
};

type ReportAnalyticsEvent = (event: AnalyticsEvent) => void;
export const reportAnalyticsEvent: ReportAnalyticsEvent = (event) => {
  enqueueAndThrottleReportAnalyticsEvents([event]);
};

type ReportAnalyticsEventNow = (event: AnalyticsEvent) => Promise<void>;

export const reportAnalyticsEventNow: ReportAnalyticsEventNow = async (event) => {
  if (!eventsAllowedForReportNow.includes(event.name)) {
    logErrorToConsole('Event not allowed for report now');

    return;
  }

  const analyticsEventInputs = await getReportAnalyticsEventsInput([event]);
  await reportAnalyticsEventsNow({
    events: analyticsEventInputs,
  });
};
